import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-setting-sharing",
  "use": "icon-setting-sharing-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol viewBox=\"0 0 16 17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-setting-sharing\">\n<path d=\"M14.0038 8.46208L8.50264 3.21094V6.21159C3.23805 6.21159 2.00122 9.98648 2.00122 13.7132C3.52061 11.7678 4.86434 10.7126 8.50264 10.7126V13.7132L14.0038 8.46208Z\" stroke-width=\"1.00189\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol